const includesSurname = (name) => /\s/.test(name.trim());

export default includesSurname;
